import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { type UserProfileData } from '@a1/shared';
import callAzureFunction from 'utils-ts/call-azure-function';
import handleError from 'utils-ts/handle-error';

const STALE_TIME_MS = 60 * 60 * 1000;

// The `UserProfileData` type supports `File` as a type for `profilePhoto`, but this endpoint only ever returns a string.
type ProfileResponse = Omit<UserProfileData, 'profilePhoto'> & {
  profilePhoto?: string | null;
};

export const useUserProfile = () => {
  const {
    data: profile,
    isLoading: loading,
    refetch,
    error
  } = useQuery({
    queryKey: ['profile', 'me'],
    queryFn: async ({ signal }) => {
      const { data } = await callAzureFunction<ProfileResponse | null>({
        url: 'profile-settings/me',
        method: 'get',
        signal
      });
      return data;
    },
    staleTime: STALE_TIME_MS
  });

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  return { profile: profile ?? null, loading, refetch };
};
